import { useEffect, useRef, useState } from 'react';
import * as S from './ModalStyle';

interface ModalProps {
  onClose: () => void;
}

export default function TicketingNotice({ onClose }: ModalProps) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [hasConfirmedNotice, setHasConfirmedNotice] = useState(false);

  const handleScroll = () => {
    const el = contentRef.current;
    if (el) {
      const isAtBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
      if (isAtBottom && !hasConfirmedNotice) {
        setHasConfirmedNotice(true); // 한 번만 true로 설정
      }
    }
  };
  const handleClick = () => {
    const el = contentRef.current;
    if (!hasConfirmedNotice && el) {
      el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
    } else {
      onClose();
    }
  };

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    const el = contentRef.current;
    if (el) {
      el.addEventListener('scroll', handleScroll);
      return () => el.removeEventListener('scroll', handleScroll);
    }
  }, []);
  return (
    <S.ModalOverlay>
      <S.ModalContainer>
        <S.ModalTitle>입장권 예매 주의사항</S.ModalTitle>
        <S.ModalContent ref={contentRef}>
          <S.NoticeTitle>[1] 예매/변경/취소 관련</S.NoticeTitle>
          <S.Notice>
            <li>예매 완료 후에는 정보 변경 및 취소가 불가합니다. </li>
            <li>
              본 예매는 선착순 마감제로 운영되며, 조기 마감 시 추가 예매는
              불가능합니다.
            </li>
          </S.Notice>
          <S.NoticeTitle>[2] 입장 관련</S.NoticeTitle>
          <S.Notice>
            <li>
              현장에서는 예약자 본인의 QR코드 또는 예약번호를 통해 입장권을
              수령합니다.
            </li>
            <li>
              예매자 본인이 직접 방문해야 하며, 타인 명의의 예매는 인정되지
              않습니다.
            </li>
            <li>
              1개의 전화번호당 1회만 예매 가능하며, 중복 예매 시 사전 통보 없이
              취소될 수 있습니다.
            </li>
            <li>
              팔찌 미수령 시 입장이 불가하니, 반드시 입장 전에 교환해주세요.
            </li>
          </S.Notice>
          <S.NoticeTitle>[3] 입장권 관련</S.NoticeTitle>
          <S.Notice>
            <li>
              예매 완료 시 발급되는 QR코드 또는 예약번호는 1회만 사용
              가능합니다.
            </li>
            <li>
              QR코드 또는 예약번호가 타인에게 유출될 경우, 입장이 제한될 수
              있습니다.
            </li>
            <li>
              분실 또는 삭제 시 현장 확인이 불가할 수 있으니 캡처/보관을
              권장합니다.
            </li>
          </S.Notice>
          <S.NoticeTitle>[4] 현장 상황/기상 관련</S.NoticeTitle>
          <S.Notice>
            <li>
              당일 기상 상황 또는 운영 상황에 따라 행사 일정이 변경 또는 취소될
              수 있습니다.
            </li>
            <li>
              본인의 부주의 또는 착오로 인한 시간 착각, 지각, 미도착 시 보상은
              불가합니다.
            </li>
          </S.Notice>
          <S.NoticeTitle>[5] 기타</S.NoticeTitle>
          <S.Notice>
            <li>
              개인정보 수집에 동의하지 않을 경우 예매를 진행할 수 없습니다.
            </li>
            <li>
              현장에는 다수의 인파가 몰릴 수 있으므로, 대중교통 이용을
              권장합니다.
            </li>
            <li>
              티켓의 상업적 거래, 양도, 전매는 금지되어 있으며, 적발 시 입장이
              제한됩니다.
            </li>
          </S.Notice>
        </S.ModalContent>
        <S.ConfirmButton type="button" onClick={handleClick}>
          {hasConfirmedNotice ? '주의사항을 모두 확인하였습니다.' : '다음'}
        </S.ConfirmButton>
      </S.ModalContainer>
    </S.ModalOverlay>
  );
}
